import { Star } from 'lucide-react'
import { cn } from '@/lib/utils'

interface StarRatingProps {
  value: number
  onChange: (value: number) => void
  readonly?: boolean
}

export const StarRating = ({ value, onChange, readonly }: StarRatingProps) => {
  return (
    <div className='flex gap-0.5'>
      {[1, 2, 3].map((star) => (
        <button
          key={star}
          type='button'
          disabled={readonly}
          onClick={() => onChange(star)}
          className={cn(
            'transition-colors',
            readonly ? 'cursor-default' : 'cursor-pointer hover:text-yellow-400',
          )}
        >
          <Star
            className={cn(
              'h-5 w-5',
              star <= value ? 'fill-yellow-400 text-yellow-400' : 'text-muted-foreground',
            )}
          />
        </button>
      ))}
    </div>
  )
}
